import { render, staticRenderFns } from "./KBEditor.vue?vue&type=template&id=5df0ee95&scoped=true&lang=pug"
import script from "./KBEditor.vue?vue&type=script&lang=js"
export * from "./KBEditor.vue?vue&type=script&lang=js"
import style0 from "./KBEditor.vue?vue&type=style&index=0&id=5df0ee95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df0ee95",
  null
  
)

export default component.exports